export const documentDefaults = {
  Document: {
    __typename: 'Document',
    pending: false
  }
}

export const documentResolvers = {
  Document: {
    pending: () => false
  }
}
